<template>
  <a href="#" data-bs-toggle="modal" :data-bs-target="'#' + id" class="btn btn-sm btn-outline-primary me-1">
    {{ buttonText }}
  </a>

  <Teleport to="body">
    <div class="modal" tabindex="-1" :id="id">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
          </div>
          <div class="modal-body">

            <ul>
              <li class="list-group-item" v-for="(contact, i) in contacts" :key="i">
                <AccountObject :data="contact" v-if="contact.account !== null && typeof contact.account === 'object'" />
                <AccountArray :data="contact" v-else-if="contact.account === false" />
              </li>
            </ul>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import AccountObject from "@/components/partner/contact/AccountObject";
import AccountArray from "@/components/partner/contact/AccountArray";

export default {
  name: 'PartnerContactsModal',

  components: {
    AccountObject,
    AccountArray
  },

  props: {
    buttonText: String,
    contacts: Object,
    id: String
  },
}
</script>

<style scoped>
a.btn-outline-primary:hover {
  color: white;
}
</style>
